interface ActionButtonProps {
  onClick: () => void;
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  className?: string;
  revealLabel?: string;
  disabled?: boolean;
}

export default function ActionButton({ 
  onClick, 
  icon: Icon, 
  label, 
  className = "", 
  revealLabel = "",
  disabled = false
}: ActionButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`flex items-center gap-1 group p-1.5 rounded-lg overflow-hidden hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors group ${className}`}
      title={label}
    >
      <Icon className="h-4 w-4 text-gray-500 dark:text-gray-400 group-hover:text-gray-700 dark:group-hover:text-gray-200" />
      {revealLabel && <span className="text-gray-700 dark:text-gray-300 hidden group-hover:block text-xs">{revealLabel}</span>}
    </button>
  );
}